/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// var visited = getCookie('visited');

// if (visited == 'True') {
//   $('.initial-load').hide();
// } else {
//   $('.initial-load').show();
//  	setCookie('visited', 'True', '1'); 
// }

  function setCookie(cname, cvalue, exdays) {
         var d = new Date();
         d.setTime(d.getTime() + (exdays*60*60*1000));
         var expires = "expires="+ d.toUTCString();
         document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
       }
       
       
       
       function getCookie(cname) {
         var name = cname + "=";
         var decodedCookie = decodeURIComponent(document.cookie);
         var ca = decodedCookie.split(';');
         for(var i = 0; i <ca.length; i++) {
           var c = ca[i];
           while (c.charAt(0) == ' ') {
             c = c.substring(1);
           }
           if (c.indexOf(name) == 0) {
             return c.substring(name.length, c.length);
           }
         }
         return "";
       }

setTimeout(function() {
  if ($('.initial-load').length > 0) {
    $('.initial-load').fadeOut();
  }
}, 4500);

//     function myFunction() {
//       setTimeout(function() {
//       	$('.initial-load').fadeOut();
//     	}, 4500);
//     }
  
//     if(visited == 'false' || localStorage.getItem("visited") == null) {
//        myFunction();

//        localStorage.setItem("visited", true);
//     } else {
//       $('.initial-load').hide();
//     }

$(document).ready(function() { 
  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  	$('.ImageHero__ImageWrapper, .ImageHero__Image, .parallax-background').addClass('fixed-background');
  }


    $('.CollectionFilters .is-selected').parent('.Linklist').show();
    $('.CollectionFilters .is-selected').parent('.Linklist').parent('.Linklist__Item').parent('.Linklist').show();
    $('.CollectionFilters .is-selected').children('.Linklist').show();

    $('#view-size-chart').click(function() {
        var sizeChart = $(this).data('size-chart');

      	$('body').append('<div class="site-overlay">' +
                         '<div class="site-overlay__inner">' +
                         '<div class="site-overlay__close">' +
                         '<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">' +
      					 '<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>' +
    					 '</svg>' +
                         '</div>' +
                         '<img class="size-chart" src="' + sizeChart + '" alt="Size Chart">' +
                         '</div>' +
                         '</div>');
      
      	$('.site-overlay').fadeIn();
    });
  
    $(document).on('click', '.site-overlay__close', function() {
        $('.site-overlay').fadeOut(function() {
          	$(this).remove();
        });
    });
  
  	$(document).click(function (e) {
        if (!$(e.target).closest('.site-overlay__inner img').length && !$(e.target).is('.site-overlay__inner img') && !$(e.target).is('#view-size-chart') && !$(e.target).is('#view-size-chart span')) {
            $('.site-overlay').fadeOut(function() {
          		$(this).remove();
        	});
        }
    });
  
    $('.Header__MainNav > .HorizontalList .HorizontalList__Item:nth-child(2)').mouseenter(function() {
      $(this).children('a').css('position', 'relative');
      $(this).children('a').append('<div class="main-nav-hover">Women\'s</div>');
    });
  
  	$('.Header__MainNav > .HorizontalList .HorizontalList__Item:nth-child(3)').mouseenter(function() {
      $(this).children('a').css('position', 'relative');
      $(this).children('a').append('<div class="main-nav-hover">Girl\'s</div>');
    });
  
  	$('.Header__MainNav > .HorizontalList .HorizontalList__Item:nth-child(4)').mouseenter(function() {
      $(this).children('a').css('position', 'relative');
      $(this).children('a').append('<div class="main-nav-hover">Little Girl\'s</div>');
    });
  
  	$('.Header__MainNav > .HorizontalList .HorizontalList__Item:nth-child(2)').mouseleave(function() {
      $('.main-nav-hover').remove();
    });
  
  	$('.Header__MainNav > .HorizontalList .HorizontalList__Item:nth-child(3)').mouseleave(function() {
      $('.main-nav-hover').remove();
    });
  
  	$('.Header__MainNav > .HorizontalList .HorizontalList__Item:nth-child(4)').mouseleave(function() {
      $('.main-nav-hover').remove();
    });
  
    /* -------------- Sidebar Menu Hover-------------*/
  
    /*$('.SidebarMenu__Nav > .Collapsible:nth-of-type(2)').mouseenter(function() {
      $(this).children('button').append("<div class='mobile-nav-hover'>Women\'s<span class='Collapsible__Plus'></span>");
    });
  
    $('.SidebarMenu__Nav > .Collapsible:nth-of-type(3)').mouseenter(function() {
      $(this).children('button').append("<div class='mobile-nav-hover'>Girl\'s<span class='Collapsible__Plus'></span>");
    });
  
    $('.SidebarMenu__Nav > .Collapsible:nth-of-type(4)').mouseenter(function() {
      $(this).children('button').append("<div class='mobile-nav-hover'>Little Girl\'s<span class='Collapsible__Plus'></span>");
    });
  
    $('.SidebarMenu__Nav > .Collapsible').mouseleave(function() {
      $('.mobile-nav-hover').remove();
    });*/
  
    $('.SidebarMenu__Nav > .Collapsible:nth-of-type(2)').children('button').append("<div class='mobile-nav-hover'>Women\'s<span class='Collapsible__Plus'></span>");
    $('.SidebarMenu__Nav > .Collapsible:nth-of-type(3)').children('button').append("<div class='mobile-nav-hover'>Girl\'s<span class='Collapsible__Plus'></span>");
    $('.SidebarMenu__Nav > .Collapsible:nth-of-type(4)').children('button').append("<div class='mobile-nav-hover'>Little Girl\'s<span class='Collapsible__Plus'></span>");
  
    /* -------------- Sidebar Menu Hover End-------------*/
  
  
  	var gifSource = $('#gif_animata').attr('src'); //get the source in the var
    $('#gif_animata').attr('src', ""); //erase the source     
    // $('#gif_animata').attr('src', gifSource+"?"+new Date().getTime()); //add the date to the source of the image... :-) 
  
//   $(window).resize(function() {
//     if ($(window).width() > 641) {
//     	$('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
//          $('.category-embed').css('height', $('.ProductItem__Image').outerHeight() + 'px');    


//     	$('.category-embed__inner').css('height', $('.ProductItem__Image').outerHeight() + 'px');
//     }
//   });
  
//   $('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
//   $('.category-embed').css('height', $('.ProductItem__Image').outerHeight() + 'px');    
//     	$('.category-embed__inner').css('height', $('.ProductItem__Image').outerHeight() + 'px');
  
//   setTimeout(function() {
//       if ($(window).width() > 641) {
//         $('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
//     	$('.category-embed').css('height', $('.ProductItem__Image').outerHeight() + 'px');    
//     	$('.category-embed__inner').css('height', $('.ProductItem__Image').outerHeight() + 'px');
//       }
//   }, 1000);
  
  if ($(window).width() > 641) {
        $('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
    $('.category-embed').css('height', $('.ProductItem__Image:nth-child(2)').outerHeight() + 'px');    
    	$('.category-embed__inner').css('height', $('.ProductItem__Image:nth-child(2)').outerHeight() + 'px');
    $('.category-embed').parent('.Grid__Cell').css('padding-top', (($('.ProductItem__ImageWrapper').outerHeight() - $('.ProductItem__Image:nth-child(2)').outerHeight()) / 2) + 'px');
  } else if ($(window).width() > 641) {
         $('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
    $('.category-embed').css('height', $('.ProductItem__Image').outerHeight() + 'px');    
    	$('.category-embed__inner').css('height', $('.ProductItem__Image').outerHeight() + 'px');
    $('.category-embed').parent('.Grid__Cell').css('padding-top', (($('.ProductItem__ImageWrapper').outerHeight() - $('.ProductItem__Image').outerHeight()) / 2) + 'px');
  }
  
  setInterval(function() {
    if ($(window).width() > 641) {
        $('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
    $('.category-embed').css('height', $('.ProductItem__Image:nth-child(2)').outerHeight() + 'px');    
    	$('.category-embed__inner').css('height', $('.ProductItem__Image:nth-child(2)').outerHeight() + 'px');
    $('.category-embed').parent('.Grid__Cell').css('padding-top', (($('.ProductItem__ImageWrapper').outerHeight() - $('.ProductItem__Image:nth-child(2)').outerHeight()) / 2) + 'px');
  } else if ($(window).width() > 641) {
         $('.category-embed__wrapper').css('height', $('.ProductItem__ImageWrapper').outerHeight() + 'px');
    $('.category-embed').css('height', $('.ProductItem__Images').outerHeight() + 'px');    
    	$('.category-embed__inner').css('height', $('.ProductItem__Image').outerHeight() + 'px');
    $('.category-embed').parent('.Grid__Cell').css('padding-top', (($('.ProductItem__ImageWrapper').outerHeight() - $('.ProductItem__Image').outerHeight()) / 2) + 'px');
  }
  }, 500);
    
 
  $('.ProductForm__AddToCart.claim-gift-button').on('click',function(){
  	$('.ProductForm__AddToCart.claim-gift-button').prop('disabled', true);
  })
  
  
  //Hide $0 Hidden By Bold
   $('.ProductItem__Price.Text--subdued').filter(function(){
   return $(this).text().trim() === "$0";
 }).closest('.Grid__Cell').hide();

  /*
  /********************  Free Gift Popup issue  ***********************/
  /*
  var closedFreeGift = getCookie('closed-free-gift');

  if (closedFreeGift != 'True') {
    setTimeout(function() {
      $('#free-gift-overlay').fadeIn();
      $('html').css('overflow', 'hidden');
      $('body').css({
        overflow: 'hidden',
        position: 'relative',
      });
    }, 3000);
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }*/
  
  
//   $(document).on('click', 'a.CartItem__Remove', function(e){
  // $(document).on('click', '.Cart__Checkout', function(e){
  //   //return;
  //   e.preventDefault();
    
  //   jQuery.getJSON('/cart.js', function(cart) {
  //     var has_free_gift = 0;
  //     var i = 0, count = 0;

  //     for (i = 0; cart.items[i]; i++) {
  //       count = i;
  //     }

  //     console.log (cart.item_count, cart.items, count);

  //     if (cart.items[0].final_price == 0) {
  //       document.cookie = "closed-free-gift=;" + "path=/";
  //     }
      
  //     if (count == 1) {
  //       for (i = 0; cart.items[i]; i++) {
  //         console.log (cart.items[i].final_price);
  //         if (cart.items[i].final_price == 0) {
  //           has_free_gift = 1;
  //           console.log ('has free gift');
  //           break;
  //         }
  //       }

  //       if (has_free_gift) {
  //         console.log ('has free gift ajax');
  //         $.ajax({
  //           type: "POST",
  //           url: '/cart/clear.js',
  //           dataType: 'json',
  //           success: function(){
  //             console.log('cleared the cart!');
              
  //             document.cookie = "closed-free-gift=;" + "path=/";
              
  //             setTimeout(function(){
  //               location.reload();
  //             }, 300);
  //           }
  //         });

  //       }
  //     } else {
  //       console.log('submit cart form')
  //       $('.Cart Cart--expanded').submit();
  //     }
  //   });
  // })
  
  /*$(document).on('click', 'button.Cart__Checkout', function(e){
    jQuery.getJSON('/cart.js', function(cart) {
      var free_gift_count = 0;
      var i = 0, count = -1;

      for (i = 0; cart.items[i]; i++) {
        count = i;
        if (cart.items[0].final_price == 0) {
          free_gift_count++;
        }
      } 
      
      console.log ('free gift count ' + free_gift_count);
      
      if ((count == 0 & cart.items[0].final_price == 0) || free_gift_count > 1) {
        alert ('Must have at least one priced item in cart to check out!');
        //location.reload();
        //window.location.href = location.href;
        window.location = '/cart';
        e.preventDefault();    
        //e.stopPropagation();

        //return false;
        
        
      } else {
        //$(this).trigger('click');
      }
    });
  })*/
//  if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
//   BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
// }

    //    $.getJSON('/cart.js', function(cart) {
    //    });


  
  });
  
// Copy to clipboard
new ClipboardJS('.clipboard-btn');


// Mobile Sticky ATC
$(document).ready(function() {

  if($('.Product_StickyATC').length > 0 ) {
    let atc = document.querySelector('.ProductForm__AddToCart ')
    let stickyAtc = document.querySelector('.Product_StickyATC')
    let form = document.querySelector('.ProductForm')

    window.addEventListener('scroll', function(e) {
      if (window.scrollY >= (atc.getBoundingClientRect().top + window.scrollY)) {
        stickyAtc.classList.add('active')
      } else {
        stickyAtc.classList.remove('active')
      }
    }, { passive: true })

    $('.Product_StickyATC').click(function(){
      form.scrollIntoView({
        behavior: 'smooth'
      })
    });
  }

});